
import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedPrototypesListScreen = () => (
  <SharedContentListContainer listType="prototypes" />
);

export default SharedPrototypesListScreen;
